import { render } from "./FattureFornitoriGrezze.vue?vue&type=template&id=693a7edf&scoped=true"
import script from "./FattureFornitoriGrezze.vue?vue&type=script&lang=js"
export * from "./FattureFornitoriGrezze.vue?vue&type=script&lang=js"

import "./FattureFornitoriGrezze.vue?vue&type=style&index=0&id=693a7edf&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693a7edf"]])

export default __exports__